import { modalsVar, appVar } from "../../cache";
import { createModalMutations } from "./modal";
import { createAppMutations } from "./app";

export const {
  initializeModalState,
  closeModal,
  openModal,
  openPrescriptionCompletedModal,
  openResetModal,
  openSecretCodeModal,
  openConfirmUsedCodeModal,
  openExtendPrescriptionCodeExpiryCompletedModal,
} = createModalMutations(modalsVar);

export const {
  showHeader,
  hideHeader,
  showMenuList,
  hideMenuList,
  showSnackBar,
  hideSnackBar,
  enableScroll,
  disableScroll,
  setNotFoundStatus,
  setForbiddenStatus,
  setServerErrorStatus,
  setNotSameSubDomainStatus,
} = createAppMutations(appVar);
